export const smallApplianceModelsAllowed = ["FORGE02S6VM","FORGE02CUPS","FORGE02PACK","XPIO13BCBT","G8P1AASSPSS"];
export const customerClassCodeElements =['HOSPITALITY DIRECT NEW CONST','APARTMENT REPLACEMENT DIST','DIRECT PROPERTY MGT REHAB','DPMR','HOME WARRANTY',
    'MULTIFAMILY FOR RENT','MULTIFAMILY FOR SALE','SINGLE FAMILY','SINGLE FAMILY RENOVATION' ];

export const SHIPPING_METHODS_FOR_DELIVERY_CALENDAR = [{
        name: 'SDS Delivery',
        type: 'SDS'
    }, {
        name: 'SDS Will Call',
        type: 'SDS'
    }, {
        name: 'ADC Truckload',
        type: 'ADC'
    }, {
        name: 'ADC LTL',
        type: 'ADC'
    }, {
        name: 'ADC Box Truck',
        type: 'ADC'
    }, {
        name: 'ADC Velocity',
        type: 'ADC'
    }, {
         name: 'Factory Direct Truckload',
        type: 'Factory Direct Truckload'
    },{
        name: 'MATU-Ocean-Ocean-Full Container',
        type: 'ADC'
    }];

export const CUSTOMER_CLASS_CODES_FOR_HOLD_OR_FORCE_BACKORDER = [
    'NON NATIONAL',
    'APPLIANCE BUILDER DISTRIBUTOR',
    'APARTMENT REPLACEMENT DIST',
    'RENTAL'
    ];

export const userDetailsForStandardTemplate = {
    ssoId : 502306482,
    accountNumber : 88336845
    };

export const ADJUSTED_TERMS_CUSTOMER_CLASSES = [
    'NON NATIONAL',
    'APPLIANCE BUILDER DISTRIBUTOR',
    'APARTMENT REPLACEMENT DIST',
    'AWS PRO - DISTRIBUTORS',
    'HOSPITALITY DISTRIBUTOR',
    'HOSPITALITY MECH CONTRACTOR'
    ];


// WEBPACK FOOTER //
// ./src/App/components/common/LookUpTable.js